// набор функций для очистки примитивных данных

/**
 * Возвращает строку, в начале которой гарантированно будет переданный префикс, не допуская дублирования, если он уже имеется в начале исходной строки
 * @param str исходная строка
 * @param prefix префикс
 */
const prefixAppender = (str: string, prefix: string) =>
  str?.indexOf(prefix) === 0 ? str : prefix + str
/**
 * Возвращает строку, очищенную от переданного префикса, если таковой будет иметься в начале исходной строки
 * @param str исходная строка
 * @param prefix префикс
 */
const prefixRemover = (str: string, prefix: string) =>
  str?.indexOf(prefix) === 0 ? str.substring(prefix.length) : str

/** Гарантирует наличие слеша в начале строки
 * @param str исходная строка
 * @param checkProtocol
 * @returns строка str, в начале которой присутстует '/'
 * @example
 * 'abc' -> '/abc'
 * '/abc' -> '/abc'
 */
const withPrefixSlash = (str: string, checkProtocol = true) => {
  if (checkProtocol && (str.startsWith('http') || str.startsWith('https')))
    return str

  return prefixAppender(str, '/')
}

/** Гарантирует наличие двойного слеша в начале строки
 * @param str исходная строка
 * @returns строка str, в начале которой присутстует '//'
 * @example
 * 'abc' -> '//abc'
 * '//abc' -> '//abc'
 */
const withPrefixDoubleSlash = (str: string) => prefixAppender(str, '//')

/** Гарантирует отсутствие слеша в начале строки
 * @param str исходная строка
 * @returns строка str, в начале которой отсутствует '/'
 * @example
 * '/abc' -> 'abc'
 * 'abc' -> 'abc'
 */
const withoutPrefixSlash = (str: string) => prefixRemover(str, '/')

const trailingSlashRemover = (str: string): string => {
  const index = str?.lastIndexOf('/')

  return index === str.length - 1 ? str.substring(0, index) : str
}

const sanitizeScript = (element: any) => {
  const scripts = element.querySelectorAll('script')

  let index = scripts.length

  while (index--) {
    scripts[index]?.parentNode?.removeChild(scripts[index])
  }
}

export {
  withPrefixSlash,
  withPrefixDoubleSlash,
  withoutPrefixSlash,
  prefixRemover,
  trailingSlashRemover,
  sanitizeScript,
}
